
import { defineComponent } from "vue";

export default defineComponent({
  name: "upload-cv-button"
});
